import { render, staticRenderFns } from "./CreateAccountNumber.vue?vue&type=template&id=06b0e1d1"
import script from "./CreateAccountNumber.vue?vue&type=script&lang=js"
export * from "./CreateAccountNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports